// This file is generated by pnpm icons:generate. Do not edit.

import {createSinglePathSVG} from './TEMPLATE'

export const Camera_Filled_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'M19.5 5.25h-2.599l-1.278-1.916A.75.75 0 0 0 15 3H9a.75.75 0 0 0-.623.334L7.097 5.25H4.5A2.25 2.25 0 0 0 2.25 7.5V18a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18V7.5a2.25 2.25 0 0 0-2.25-2.25Zm-4.125 7.125A3.375 3.375 0 1 1 12 9a3.375 3.375 0 0 1 3.375 3.375Z',
  viewBox: '0 0 24 24',
  glyph: 'Camera_Filled_Stroke2_Corner0_Rounded',
})

export const Camera_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'M19.5 5.25h-2.599l-1.278-1.916A.75.75 0 0 0 15 3H9a.75.75 0 0 0-.623.334L7.097 5.25H4.5A2.25 2.25 0 0 0 2.25 7.5V18a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18V7.5a2.25 2.25 0 0 0-2.25-2.25ZM20.25 18a.75.75 0 0 1-.75.75h-15a.75.75 0 0 1-.75-.75V7.5a.75.75 0 0 1 .75-.75h3a.75.75 0 0 0 .624-.334L9.401 4.5h5.197l1.278 1.916a.75.75 0 0 0 .624.334h3a.75.75 0 0 1 .75.75ZM12 8.25a4.125 4.125 0 1 0 4.125 4.125A4.13 4.13 0 0 0 12 8.25ZM12 15a2.625 2.625 0 1 1 2.625-2.625A2.625 2.625 0 0 1 12 15Z',
  viewBox: '0 0 24 24',
  glyph: 'Camera_Stroke2_Corner0_Rounded',
})
